{
  "resourceType": "Bundle",
  "type": "searchset",
  "total": 16,
  "link": [
    {
      "relation": "self",
      "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation?patient=e.Evi4toMFqPiXu0iCJJ3MA3&_count=1000&code=26508-2,35332-6,764-1,30180-4,706-2,707-0,26446-5,709-6,26449-9,711-2,712-0,26450-7,713-8,714-6,4576-5,71865-0,71864-3,71863-5,32682-7,38524-5,42246-9,4633-4,718-7,59260-0,30313-1,14775-1,20509-6,55782-7,30351-1,76768-1,30350-3,76769-9,75928-2,93846-4,20570-8,71833-8,71831-2,71829-6,4544-3,4545-0,48703-3,31100-1,42908-4,41654-5,26474-7,731-0,732-8,26478-8,736-9,737-7,30433-7,739-3,28541-1,740-1,71668-8,40651-2,26484-6,742-7,743-5,26485-3,5905-5,744-3,30444-4,746-8,30445-1,747-6,30446-9,748-4,26498-6,749-2,71667-0,26499-4,751-8,753-4,26511-6,770-8,23761-0,30458-4,24103-4,13047-6,79426-3,28542-9,32623-1,26515-7,777-3,49497-1,778-1,30465-9,6746-2,34926-6,33855-8,30466-7,13599-6,26523-1,781-5,26524-9,783-1,71666-2,26453-1,789-8,790-6,14196-0,60474-4,40665-2,26464-8,6690-2,49498-9,804-5,1754-1,6942-7,77158-4,1751-7,61151-7,61152-5,2862-1,1952-1,76484-5,35194-0,1975-2,14631-6,77137-8,2532-0,14804-9,14805-6,35214-6,2498-4,14798-3,35215-3,2500-7,14800-7,35209-6,24373-3,2276-4,20567-4,11150-0,57028-3,26505-8,32200-8,769-0,4679-7,17849-1,31112-6,708-8,30376-8,26444-0,704-7,705-4,6863-5"
    }
  ],
  "entry": [
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezssXRBIVJXbvFjD5xlNTCjNLqNP-N6MBVfv8F5Uj.Asrol-q0thyfDd.XAUCI8X43"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ezssXRBIVJXbvFjD5xlNTCjNLqNP-N6MBVfv8F5Uj.Asrol-q0thyfDd.XAUCI8X43",
      "resource": {
        "resourceType": "Observation",
        "id": "ezssXRBIVJXbvFjD5xlNTCjNLqNP-N6MBVfv8F5Uj.Asrol-q0thyfDd.XAUCI8X43",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ec8rMVv0dI6Pm5UwnStL2-Q3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2276-4",
              "display": "Ferritin [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Ferritin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:59Z",
        "valueQuantity": {
          "value": 96,
          "unit": "ng/ml",
          "system": "http://unitsofmeasure.org",
          "code": "ng/ml"
        },
        "referenceRange": [
          {
            "low": {
              "value": 12,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "high": {
              "value": 150,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "text": "12.0 - 150.0 ng/ml"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ef0NIOh6W-EwnxO3hhBwJI9JtXEmP9HmWKWZ4ik-HFSSk9KUZV1fl9JWyVPVCfKvh3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/ef0NIOh6W-EwnxO3hhBwJI9JtXEmP9HmWKWZ4ik-HFSSk9KUZV1fl9JWyVPVCfKvh3",
      "resource": {
        "resourceType": "Observation",
        "id": "ef0NIOh6W-EwnxO3hhBwJI9JtXEmP9HmWKWZ4ik-HFSSk9KUZV1fl9JWyVPVCfKvh3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eLHFALqjX9CuVpf-aw5-gKw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "2276-4",
              "display": "Ferritin [Mass/volume] in Serum or Plasma"
            }
          ],
          "text": "Ferritin"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:55Z",
        "valueQuantity": {
          "value": 96,
          "unit": "ng/ml",
          "system": "http://unitsofmeasure.org",
          "code": "ng/ml"
        },
        "referenceRange": [
          {
            "low": {
              "value": 15,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "high": {
              "value": 300,
              "unit": "ng/ml",
              "system": "http://unitsofmeasure.org",
              "code": "ng/ml"
            },
            "text": "15.0 - 300.0 ng/ml"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu10ftKdzuwD6UJ9I72-YYV3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu10ftKdzuwD6UJ9I72-YYV3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCJ-02KQCo3VKIzy5oWhW.Vu10ftKdzuwD6UJ9I72-YYV3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": { "value": 411, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.LrC2PcHbpZE5L3mkyy3-QN3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.LrC2PcHbpZE5L3mkyy3-QN3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyXhoZIVOoyIAgdrAGsISA.LrC2PcHbpZE5L3mkyy3-QN3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": { "value": 411, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN4hmNL-gxXbfMZLfAJtBGvL3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN4hmNL-gxXbfMZLfAJtBGvL3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8SdbUZ9O1hv8T-0GZ.Q5jdN4hmNL-gxXbfMZLfAJtBGvL3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": { "value": 432, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhuBEBVGmVQgpGCOdS3VrDsR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhuBEBVGmVQgpGCOdS3VrDsR3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx5RjnJAwGjMED1R17HQRmhuBEBVGmVQgpGCOdS3VrDsR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": { "value": 401, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1ybKb0RU8EU8SBfJP2z5K273"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1ybKb0RU8EU8SBfJP2z5K273",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1whMEdGw969zadcAnl6eOb1ybKb0RU8EU8SBfJP2z5K273",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": { "value": 399, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQNVzfrqe7RFKs8zYcQncJd3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQNVzfrqe7RFKs8zYcQncJd3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9Vj3m4wzhMS4EdLJqtsa0HZQNVzfrqe7RFKs8zYcQncJd3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "26515-7",
              "display": "Platelets [#/volume] in Blood"
            }
          ],
          "text": "Platelets"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": { "value": 375, "unit": "X 10E9/L" },
        "referenceRange": [
          {
            "low": { "value": 150, "unit": "X 10E9/L" },
            "high": { "value": 450, "unit": "X 10E9/L" },
            "text": "150 - 450 X 10E9/L"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCBA5Uh-lrHxLojzQKuQiSVm3gm--729jZ2iYu3r8-zT53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCBA5Uh-lrHxLojzQKuQiSVm3gm--729jZ2iYu3r8-zT53",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCBA5Uh-lrHxLojzQKuQiSVm3gm--729jZ2iYu3r8-zT53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "32623-1",
              "display": "Platelet mean volume [Entitic volume] in Blood by Automated count"
            }
          ],
          "text": "MPV"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": {
          "value": 9.7,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 7.4,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 10.9,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "7.4 - 10.9 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyeNuW5XUiYcfnl.Q-KkdgOfPO4VugALi6z8kkYz6Thg53"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.EyeNuW5XUiYcfnl.Q-KkdgOfPO4VugALi6z8kkYz6Thg53",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.EyeNuW5XUiYcfnl.Q-KkdgOfPO4VugALi6z8kkYz6Thg53",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "32623-1",
              "display": "Platelet mean volume [Entitic volume] in Blood by Automated count"
            }
          ],
          "text": "MPV"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": {
          "value": 9.7,
          "unit": "fL",
          "system": "http://unitsofmeasure.org",
          "code": "fL"
        },
        "referenceRange": [
          {
            "low": {
              "value": 7.6,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "high": {
              "value": 10.8,
              "unit": "fL",
              "system": "http://unitsofmeasure.org",
              "code": "fL"
            },
            "text": "7.6 - 10.8 fL"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCD9Vdli8cXLYjtX0t3MEhrPbf.G09dyIYFBAx20odMZC3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eE3RyNS1w7uRjZJ9yRmfgCD9Vdli8cXLYjtX0t3MEhrPbf.G09dyIYFBAx20odMZC3",
      "resource": {
        "resourceType": "Observation",
        "id": "eE3RyNS1w7uRjZJ9yRmfgCD9Vdli8cXLYjtX0t3MEhrPbf.G09dyIYFBAx20odMZC3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eIFdSvu8ignN6YImaCLFJ1g3"
          }
        ],
        "status": "amended",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/ezvHaHi-CRPxO301XL-cixQ3"
        },
        "effectiveDateTime": "2004-08-06T05:00:00Z",
        "issued": "2005-03-07T06:29:57Z",
        "valueQuantity": {
          "value": 39.8,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 34.9,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 44.5,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "34 - 44 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.Eydmj8jMCSwJmkXv7N5IFoRV3Ht24AIE39jBD7pkt4sbY3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/e9c9HEXoUVbH2yh0ZoA.Eydmj8jMCSwJmkXv7N5IFoRV3Ht24AIE39jBD7pkt4sbY3",
      "resource": {
        "resourceType": "Observation",
        "id": "e9c9HEXoUVbH2yh0ZoA.Eydmj8jMCSwJmkXv7N5IFoRV3Ht24AIE39jBD7pkt4sbY3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eHK6zfhRTPo3ZF.HDH3mLnA3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eTMVZSQTgx5SgR-qmLUEG9Q3"
        },
        "effectiveDateTime": "2003-06-10T05:00:00Z",
        "issued": "2003-12-14T04:18:38Z",
        "valueQuantity": {
          "value": 43.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8ScWX6lrNK6mjgdJVGquv5ge3EFjfnrXCH8M5RXO1ThXR3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/evq5ABC1.1KDEBOKBe-e8ScWX6lrNK6mjgdJVGquv5ge3EFjfnrXCH8M5RXO1ThXR3",
      "resource": {
        "resourceType": "Observation",
        "id": "evq5ABC1.1KDEBOKBe-e8ScWX6lrNK6mjgdJVGquv5ge3EFjfnrXCH8M5RXO1ThXR3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/egJPf2hCzGd1jVpiTcLqhXg3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/emDOGK2vMuAK2-4OQK0G64w3"
        },
        "effectiveDateTime": "2000-06-16T05:00:00Z",
        "valueQuantity": {
          "value": 44.4,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx.s2MiMAvVT7bSBONZiLSYKLHNZLuykj2liAjO.J0AzM3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eiCLprvQB8g0oVfmfBMarx.s2MiMAvVT7bSBONZiLSYKLHNZLuykj2liAjO.J0AzM3",
      "resource": {
        "resourceType": "Observation",
        "id": "eiCLprvQB8g0oVfmfBMarx.s2MiMAvVT7bSBONZiLSYKLHNZLuykj2liAjO.J0AzM3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/ewZYHbYagOm.LYOeEGNK0Bw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/e5kV0KBLrN8XgpyftM3qrRg3"
        },
        "effectiveDateTime": "1999-07-13T05:00:00Z",
        "valueQuantity": {
          "value": 40.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpuF3eOATjeS8AekZlGRgOpa4BfoEtda28QxNl1-j0hg3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eYvUo7byp.U.EmiwzmbW1wpuF3eOATjeS8AekZlGRgOpa4BfoEtda28QxNl1-j0hg3",
      "resource": {
        "resourceType": "Observation",
        "id": "eYvUo7byp.U.EmiwzmbW1wpuF3eOATjeS8AekZlGRgOpa4BfoEtda28QxNl1-j0hg3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/e58g1QNaytYMB2Uhf3gbTSw3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/eiBw2xkdDsNclz-96L6xOJA3"
        },
        "effectiveDateTime": "1997-11-18T06:00:00Z",
        "valueQuantity": {
          "value": 42.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VpMBV3ZY99aOeYzCYo0nPp2KThRakzBTqgILrajuG.Nn3"
        }
      ],
      "fullUrl": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Observation/eDgNArFx0YyvISeS.Izg9VpMBV3ZY99aOeYzCYo0nPp2KThRakzBTqgILrajuG.Nn3",
      "resource": {
        "resourceType": "Observation",
        "id": "eDgNArFx0YyvISeS.Izg9VpMBV3ZY99aOeYzCYo0nPp2KThRakzBTqgILrajuG.Nn3",
        "basedOn": [
          {
            "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/ProcedureRequest/eyf3Px-72olS83NqC97Hi5w3"
          }
        ],
        "status": "final",
        "category": [
          {
            "coding": [
              {
                "system": "http://hl7.org/fhir/observation-category",
                "code": "laboratory",
                "display": "Laboratory"
              }
            ],
            "text": "Laboratory"
          },
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.798268.30",
                "code": "Lab",
                "display": "Lab"
              }
            ],
            "text": "Lab"
          }
        ],
        "code": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "4544-3",
              "display": "Hematocrit [Volume Fraction] of Blood by Automated count"
            }
          ],
          "text": "Hematocrit"
        },
        "subject": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Patient/e.Evi4toMFqPiXu0iCJJ3MA3",
          "display": "Newman, Kelly"
        },
        "context": {
          "reference": "https://apporchard.epic.com/interconnect-aocurprd-oauth/api/FHIR/STU3/Encounter/etDAp4fXggD42w7zCp6S2bA3"
        },
        "effectiveDateTime": "1996-11-02T06:00:00Z",
        "valueQuantity": {
          "value": 42.9,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "referenceRange": [
          {
            "low": {
              "value": 38.8,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "high": {
              "value": 50,
              "unit": "%",
              "system": "http://unitsofmeasure.org",
              "code": "%"
            },
            "text": "38 - 50 %"
          }
        ]
      },
      "search": { "mode": "match" }
    },
    {
      "resource": {
        "resourceType": "OperationOutcome",
        "issue": [
          {
            "severity": "warning",
            "code": "processing",
            "details": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.657369",
                  "code": "4119",
                  "display": "This response includes information available to the authorized user at the time of the request. It may not contain the entire record available in the system."
                }
              ],
              "text": "This response includes information available to the authorized user at the time of the request. It may not contain the entire record available in the system."
            }
          }
        ]
      },
      "search": { "mode": "outcome" }
    }
  ]
}
